const publicUrl = process.env.PUBLIC_URL || ''

const SOUND_CLOSED = `${publicUrl}/sounds/text_message.mp3`
const SOUND_OPEN = `${publicUrl}/sounds/whatsapp_notification.mp3`
const SOUND_SPECIAL = `${publicUrl}/sounds/barking_dog.mp3`

let initialized = false
let unlocked = false
let soundClosed = null
let soundOpen = null

const getUserId = () => {
  try {
    return Number(JSON.parse(localStorage.getItem('user') || '{}')?.user_id)
  } catch (error) {
    return null
  }
}

const pickSrc = (whenChatOpen) => {
  if (getUserId() === 667) return SOUND_SPECIAL
  return whenChatOpen ? SOUND_OPEN : SOUND_CLOSED
}

const primeAudio = (audio) => {
  if (!audio) return
  const playPromise = audio.play()
  if (playPromise && typeof playPromise.then === 'function') {
    playPromise
      .then(() => {
        audio.pause()
        audio.currentTime = 0
      })
      .catch(() => {})
  }
}

export const initChatNotificationSound = () => {
  if (initialized) return
  initialized = true

  soundClosed = new Audio(pickSrc(false))
  soundOpen = new Audio(pickSrc(true))
  soundClosed.preload = 'auto'
  soundOpen.preload = 'auto'

  const unlock = () => {
    unlockChatNotificationSound()
  }

  ;['click', 'keydown', 'touchstart'].forEach((eventName) => {
    window.addEventListener(eventName, unlock, { once: true, passive: true })
  })
}

export const unlockChatNotificationSound = () => {
  initChatNotificationSound()
  if (unlocked) return
  unlocked = true
  soundClosed?.load()
  soundOpen?.load()
  primeAudio(soundClosed)
  primeAudio(soundOpen)
}

export const playChatNotificationSound = ({ whenChatOpen = false } = {}) => {
  initChatNotificationSound()
  if (!unlocked) return

  const preferred = whenChatOpen ? soundOpen : soundClosed
  const fallback = whenChatOpen ? soundClosed : soundOpen
  const audio = preferred || fallback
  if (!audio) return

  try {
    audio.currentTime = 0
    audio.play().catch(() => {})
  } catch (error) {
    // ignore autoplay blocks
  }
}

export const isChatNotificationSoundReady = () => unlocked
